import React from 'react';
import { Stagger, StaggerItem } from '../LandingMotion';

// Hero metric row. These are aspirational capability figures, NOT customer results —
// so the row is explicitly labeled illustrative/demo. (VH's truthful product numbers —
// 40+ skills, 214 calculators, 5 trades — live in the StatsSection further down.)
const METRICS = [
  { val: '100K+', label: 'daily safety decisions supported' },
  { val: '98.7%', label: 'JSA completion accuracy' },
  { val: '15 min', label: 'avg. foreman time saved / day' },
  { val: '24/7', label: 'jobsite risk monitoring' },
];

const NUM_CLASS = 'text-3xl md:text-4xl font-bold tracking-tighter mb-1.5 text-transparent bg-clip-text bg-gradient-to-br from-white to-slate-400 vh-nums';

export default function HeroMetrics() {
  return (
    <div className="w-full">
      <Stagger stagger={0.08} delayChildren={0.1} className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8">
        {METRICS.map((m, i) => (
          <StaggerItem key={m.label} y={16}>
            <div className={`md:px-1 ${i > 0 ? 'md:border-l md:border-white/10 md:pl-8' : ''}`}>
              <div className={NUM_CLASS}>{m.val}</div>
              <div className="text-sm text-slate-400 leading-snug max-w-[180px]">{m.label}</div>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
      <p className="mt-6 text-[11px] text-slate-500 flex items-center gap-1.5">
        <span className="font-mono uppercase tracking-widest text-slate-600 border border-white/10 rounded px-1.5 py-0.5">Demo</span>
        Illustrative capability figures shown in demo — not customer results.
      </p>
    </div>
  );
}
